import { render, staticRenderFns } from "./ClinicianListNav.vue?vue&type=template&id=1c6c7fc6"
import script from "./ClinicianListNav.vue?vue&type=script&lang=js"
export * from "./ClinicianListNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports